import { useEffect, useState } from "react";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {  useNavigate } from "react-router-dom";
import Form from "../../components/common/Form/From";
import LoginForm from "../../components/Login/LoginForm";
import rightImage from "../../resources/images/user_rightIcon.svg";
import logo from "../../resources/images/ats-blue.svg";
import styles from "./Login.module.scss";
import { authActions } from "../../actions/auth.actions";
const LoginPage = () => {
  const initialValues = {
    username: "",
    password: "",
  };
  const [submited, setSubmited] = useState(false);
  const loggingIn = useSelector((state) => state.authentication);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (loggingIn?.loggedIn) {
      // navigate("/");
      navigate("/applicants")
    }
  }, [loggingIn?.loggedIn]);

  const SigninSchema = yup.object().shape({
    username: yup
      .string()
      .email("Please enter valid email address")
      .required("Email is required"),
    password: yup
      .string()
      .max(15, "Too Long!")
      .required("Password is required"),
  });

  const handleSubmit = (values) => {
    setSubmited(true);
    if (values.username && values.password) {
      // get return url from location state or default to home page
      setTimeout(() => {
        let platform = 'ats'
        dispatch(authActions.login(values.username, values.password ,platform , navigate));
        setSubmited(false);
      }, 1000);
    }
  };

  const renderForm = (errors, touched) => {
    return <LoginForm errors={errors} touched={touched} submited={submited} />;
  };

  return (
    <div className={`${styles.loginContainer} container-fluid`}>
      <div className="row h-100">
        <div
          className={`${styles.signInPage} col-md-6 d-flex justify-content-center`}
        >
          <img
            src={logo}
            alt="ATS Logo"
            className={`${styles.signInLogo} position-absolute`}
          />
          <Form
            initialValues={initialValues}
            validationSchema={SigninSchema}
            handleSubmit={handleSubmit}
            renderForm={renderForm}
          />
        </div>
        <div className={`${styles.rightBgImage} col-6 d-none d-md-flex`}>
          <img src={rightImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
